import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { EditTemplatePageSecondaryNav } from './EditTemplatePageSecondaryNav'
import { IFRAME_CONTAINER_ID } from '../DesignHuddle/constants'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { SelectFlowcodeModal } from '../../../components/modals/SelectFlowcodeModal'
import { Stack } from '@dtx-company/design-system/src/components/Stack/Stack'
import { getIdFromEncodedString } from '@dtx-company/true-common/src/utils/strings'
import { setSelectedFlowcode } from '@dtx-company/inter-app/src/redux/slices/printStoreApiSlice/printStoreSlice'
import { useDesignHuddleEditor } from './EditTemplatePage.hooks'
import { useDispatch } from 'react-redux'
import { useFlowRouter } from '@dtx-company/inter-app/src/hooks/useFlowRouter'
import events from '@dtx-company/inter-app/src/event-tracking/events/templatesStore'
import type { FlowcodeType } from '@dtx-company/inter-app/src/types/flowcode'

export const EditTemplatePage = (): JSX.Element => {
  const router = useFlowRouter()
  const dispatch = useDispatch()
  const productId = router.getString('productId')
  const templateId = router.getString('productId')
  const {
    selectFlowcodeModalOpen,
    setSelectFlowcodeModalClose,
    clearCode,
    backButtonHandler,
    editorContainerRef
  } = useDesignHuddleEditor()

  const onSelectFlowcode = (code: FlowcodeType): void => {
    setSelectFlowcodeModalClose()
    const decodedId = getIdFromEncodedString(code.id)
    events.Templates_Clicked_FlowcodeInSelectFlowcodeModal(decodedId)
    dispatch(setSelectedFlowcode(code))
  }

  return (
    <Stack sx={{ height: '100%' }}>
      <EditTemplatePageSecondaryNav clearCode={clearCode} backButtonHandler={backButtonHandler} />
      <Box
        ref={editorContainerRef}
        id={IFRAME_CONTAINER_ID}
        sx={{ width: '100%', height: '100%' }}
        data-testid="design-huddle-editor-container"
      />

      {selectFlowcodeModalOpen && (
        <SelectFlowcodeModal
          open={selectFlowcodeModalOpen}
          title="Select a Flowcode for this template"
          onClose={setSelectFlowcodeModalClose}
          onSelectFlowcode={onSelectFlowcode}
          emptyStateText="You have not created any Flowcodes. Please create a Flowcode to continue."
          emptyStateOnClickCreateFlowcode={() => {
            setSelectFlowcodeModalClose()
            events.Store_Templates_TemplateEditor_Clicked_Create_Flowcode_Btn({
              templateId,
              productId
            })
            router.push({
              pathname: Routes.CREATE_FLOWCODE,
              query: {
                redirectTo: encodeURIComponent(router.asPath)
              }
            })
          }}
        />
      )}
    </Stack>
  )
}
